import React from "react"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faClock, faCheck, faTimes } from "@fortawesome/free-solid-svg-icons"

function getEditorChannel(version) {
    if (version.indexOf('-test.') !== -1) {
        return 'testing';
    } else if (version.indexOf('-dev.') !== -1) {
        return 'development';
    } else {
        return 'release';
    }
}

function formatEditorDownloadUrl(version) {
    return `/download/dreameditor/${getEditorChannel(version)}/Dream Editor Setup ${version}.exe`;
}

function EngineVersion({version}) {
    if (!version) {
        return version;
    }
    return <a href={formatEditorDownloadUrl(version)}>{version}</a>
}

class VersionEntry extends React.Component{
    render(){
        const { id, version, engineVersion, platform, versionCode, buildNumber, status, updatedAt, assetPacksVersion, gitlabPipelineUrl, separateEventBundle } = this.props.buildConfig;
        const projectId = this.props.projectId;
        let shortAssetPacksVersion = assetPacksVersion;
        // Since for now all asset packs have same name, we remove the name for better clarity.
        if (shortAssetPacksVersion?.includes('@')) {
            shortAssetPacksVersion = shortAssetPacksVersion.substring(shortAssetPacksVersion.indexOf('@') + 1);
        }
        let platformVersionCode = null;
        if (platform === 'android' || platform === 'switch') {
            platformVersionCode = versionCode;
        } else if (platform === 'ios') {
            platformVersionCode = buildNumber;
        }
        var statusComponent;
        switch(status){
            case "pending":
                statusComponent = <h5 className="col pending"><FontAwesomeIcon icon={faClock}/>&nbsp;<a href={gitlabPipelineUrl}>{status}</a></h5>
                break
            case "running":
                statusComponent = <h5 className="col running"><FontAwesomeIcon icon={faClock} />&nbsp;<a href={gitlabPipelineUrl}>{status}</a></h5>
                break
            case "success":
                statusComponent = <h5 className="col success"><FontAwesomeIcon icon={faCheck} />&nbsp;<a href={gitlabPipelineUrl}>{status}</a></h5>
                break
            case "failed":
                statusComponent = <h5 className="col failed"><FontAwesomeIcon icon={faTimes} />&nbsp;<a href={gitlabPipelineUrl}>{status}</a></h5>
                break
            case "canceled":
                statusComponent = <h5 className="col canceled"><FontAwesomeIcon icon={faTimes} />&nbsp;<a href={gitlabPipelineUrl}>{status}</a></h5>
                break
            default:
                statusComponent = <h5 className="col"><a href={gitlabPipelineUrl}>{status}</a></h5>
        }
        return (
            <div className="buildConfigForm">
            <h5 className="col">{id}</h5>
                <h5 className="col">{new Date(updatedAt).toLocaleString()}</h5>
                <h5 className="col">
                    <a href={`/api/store/project/${projectId}/source?version=${version}`}>{version}</a>
                </h5>
                <h5 className="col">
                    <EngineVersion version={engineVersion} />
                </h5>
                <h5 className="col">{shortAssetPacksVersion}</h5>
                <h5 className="col">{platformVersionCode ? `${platform}:${platformVersionCode}` : platform}</h5>
                {statusComponent}
                <h5 className="col">{`${separateEventBundle}`}</h5>
                <h5 className="col">
                    <input type="checkbox" onChange={e => {
                        this.props.setIsProdRelease(version, e.target.checked)
                        }} checked={this.props.versionIsProdReleaseMap[version]}>
                    </input>
                </h5>
            </div>
        )
    }
}

export default VersionEntry
